import React, { useEffect, useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { logoutUser } from './actions';
import { AccountCircleOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { pusher } from 'helpers/websocket';
import { setSuccessToastState } from 'Store/action';
import { AppDispatch, RootState } from 'Store/Store';
import { UserType } from 'shared/types/User.types';
import Background from 'App/Assets/images/BWSL_HERO_TEXTURE_16x9_RGB.jpg';
import LHS from './LHS/LHS';

const classes = {
  content: {
    flexGrow: 1,
    backgroundImage: `url(${Background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundRosition: 'center',
    overflow: 'auto',
    height: '100vh',
  },
  topContainer: {
    minHeight: 60,
    alignItems: 'center',
    justifyContent: 'flex-end',
    borderBottom: '1px solid rgba(255, 255, 255, 0.40)',
    backgroundColor: '#2D2926'
  },
};

const NavigationLayout: React.FC<{ children: React.ReactElement }> = ({
  children,
}): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const user: UserType | null = useSelector(({ user }: RootState) => user.user);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutUser = (): void => {
    dispatch(logoutUser()).then(() => {
      handleClose();
    });
  };

  useEffect(() => {
    if (user?.is_super_admin) {
      pusher
        .subscribe('artwork_version')
        .bind('pages_made', (data: { allowed_users_ids: any[]; brand_request_id: number }) => {
          if (data?.allowed_users_ids.includes(user?.id)) {
            dispatch(
              setSuccessToastState(
                true,
                'Artwork Pages Generated Succesully',
                data?.brand_request_id,
                true,
              ),
            );
          }
        });
      pusher
        .subscribe('client_artwork_version')
        .bind('pages_made', (data: { allowed_users_ids: any[]; brand_request_id: number }) => {
          if (data?.allowed_users_ids.includes(user?.id)) {
            dispatch(
              setSuccessToastState(
                true,
                'Artwork Pages Generated Succesully',
                data?.brand_request_id,
              ),
            );
          }
        });
    } else {
      pusher
        .subscribe('client_artwork_version')
        .bind('pages_made', (data: { allowed_users_ids: any[]; brand_request_id: number }) => {
          if (data?.allowed_users_ids.includes(user?.id)) {
            dispatch(
              setSuccessToastState(
                true,
                'Artwork Pages Generated Succesully',
                data?.brand_request_id,
              ),
            );
          }
        });
    }
  }, [dispatch, user]);

  return user?.id ? (
    <Box sx={{ display: 'flex' }}>
      <LHS user={user} />
      <Box component="main" sx={classes.content}>
        <Grid container direction="column" justifyContent="center" flexWrap="nowrap">
          <Grid container direction="row" sx={classes.topContainer} spacing={2}>
            <Button onClick={handleClick} sx={{fontFamily: "Ciron Display"}} startIcon={<AccountCircleOutlined />}>
              {user?.name}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <MenuItem
                onClick={() => {
                  handleLogoutUser();
                }}>
                Logout
              </MenuItem>
            </Menu>
          </Grid>
          {children}
        </Grid>
      </Box>
    </Box>
  ) : (
    <>{children}</>
  );
};

export default NavigationLayout;
